import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Badge.module.css';
export function Badge({ tone = 'neutral', className, ...rest }) {
    const classes = [styles.badge, tone !== 'neutral' ? styles[tone] : '', className]
        .filter(Boolean)
        .join(' ');
    return _jsx("span", { className: classes, ...rest });
}
//# sourceMappingURL=Badge.js.map